module.exports = __webpack_public_path__ + "static/manhattan-cover-image-12e6bdd9d5872d3a4d42731d37dd779c.jpg";